export default "__VITE_ASSET__DHJlRx21__"